export default class BlinkingHighlight {
  isHighlighted = false;
  isHighlightedLightOn = false;
  timer = true;
  highliteBlinkTime = 400;
  highliteBlinkTimeTotal = 2400;

  constructor() {
  }

  setHighlighting = (value) => {
    if (!this.isHighlighted && value) {
      this.startHighlightingLoop();
    } else if (this.isHighlighted && !value) {
      this.stopHighlightingLoop();
    }
    this.isHighlighted = value;
    setTimeout( () => {
      document.addEventListener("click", this.stopHighlightingLoop)
    }, 50);
    setTimeout( () => {
      this.stopHighlightingLoop();
    }, this.highliteBlinkTimeTotal);
  };

  startHighlightingLoop = () => {
    this.isHighlightedLightOn = true;
    setTimeout( () => {
      this.isHighlightedLightOn = false
    }, this.highliteBlinkTime);
    this.timer = setTimeout( () => {
      this.startHighlightingLoop();
    }, this.highliteBlinkTime * 2);
  }

  stopHighlightingLoop = () => {
    clearTimeout(this.timer);
    this.isHighlighted = false;
    //this.isHighlightedLightOn = false; // this will be done in startHighlightingLoop
    document.removeEventListener("click", this.stopHighlightingLoop);
  }
}
